import apiClient from "services/axios";

const API = {
  list: "/api/v1/monitorings",
  create: "/api/v1/monitorings",
  detail: "/api/v1/monitorings",
  update: "/api/v1/monitorings",
  delete: "/api/v1/monitorings",
};

const hasUploadFile = (file) => file && typeof file === "object";

const normalizeMonitoringBody = (body) => {
  const payload = { ...body };
  if (payload.type) {
    payload.type = String(payload.type).toLowerCase();
  }
  if (payload.bgImageFile === "" || payload.bgImageFile === undefined || payload.bgImageFile === null) {
    delete payload.bgImageFile;
  }
  return payload;
};

const toMonitoringFormData = (body) => {
  const payload = normalizeMonitoringBody(body);
  const formData = new FormData();
  formData.append("name", payload.name || "");
  formData.append("key", payload.key || "");
  if (payload.type) {
    formData.append("type", payload.type);
  }
  if (Object.prototype.hasOwnProperty.call(payload, "projectId")) {
    formData.append("projectId", payload.projectId || 0);
  }
  if (Object.prototype.hasOwnProperty.call(payload, "screenFolderId")) {
    formData.append("screenFolderId", payload.screenFolderId || 0);
  }
  formData.append("description", payload.description || "");
  if (payload.bgImageFile) {
    formData.append("bgImageFile", payload.bgImageFile);
  }
  if (Object.prototype.hasOwnProperty.call(payload, "scadaConfig")) {
    formData.append("scadaConfig", payload.scadaConfig || "");
  }
  return formData;
};

export const list = async (filter) => {
  const response = await apiClient.get(API.list, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};

export const create = async (body) => {
  const payload = hasUploadFile(body.bgImageFile) ? toMonitoringFormData(body) : normalizeMonitoringBody(body);

  const response = await apiClient.post(API.create, payload);
  if (response) {
    return response.data;
  }
  return false;
};

export const detail = async (id, filter) => {
  const response = await apiClient.get(`${API.detail}/${id}`, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};

export const scadaConfigVersion = async (id) => {
  const response = await apiClient.get(`${API.detail}/${id}/scada-config-version`);
  if (response) {
    return response.data;
  }
  return false;
};

export const scadaRuntimeSnapshot = async (id) => {
  const response = await apiClient.get(`${API.detail}/${id}/scada-runtime-snapshot`);
  if (response) {
    return response.data;
  }
  return false;
};

export const touchScadaRuntimeSession = async (id, sessionId) => {
  const response = await apiClient.put(
    `${API.detail}/${id}/scada-runtime-sessions/${encodeURIComponent(sessionId)}`
  );
  return response?.data || false;
};

export const closeScadaRuntimeSession = async (id, sessionId) => {
  const response = await apiClient.delete(
    `${API.detail}/${id}/scada-runtime-sessions/${encodeURIComponent(sessionId)}`
  );
  return response?.data || false;
};

export const dispatchScadaEvent = async (id, event) => {
  const response = await apiClient.post(`${API.detail}/${id}/scada-events`, event);
  if (response) {
    return response.data;
  }
  return false;
};

export const validateScadaScript = async (id, source, scadaConfig) => {
  const response = await apiClient.post(`${API.detail}/${id}/scada-scripts/validate`, { source, scadaConfig });
  if (response) {
    return response.data;
  }
  return false;
};

export const update = async (id, body) => {
  const payload = hasUploadFile(body.bgImageFile) ? toMonitoringFormData(body) : normalizeMonitoringBody(body);
  const response = await apiClient.patch(`${API.update}/${id}`, payload);
  if (response) {
    return response.data;
  }
  return false;
};

export const updateScadaConfig = async (id, scadaConfig) => {
  const response = await apiClient.patch(
    `${API.update}/${id}`,
    { scadaConfig },
    { propagateError: true }
  );
  if (response) {
    return response.data;
  }
  return false;
};

export const remove = async (id) => {
  const response = await apiClient.delete(`${API.delete}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};
